<template>
  <div class="app-container">
    <md-toolbar class="md-title" v-if="status.loggedIn" md-elevation="1">
      <h3 class="md-title" style="flex: 1">KorentoAdmin</h3>
      <navigation-bar></navigation-bar>
      <md-button v-on:click="logout()" class="md-primary">Kirjaudu ulos</md-button>
    </md-toolbar>
    <div id="app-centered">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'korento-admin',
  components: {
    NavigationBar
  },
  computed: {
    ...mapState('account', ['status', 'account'])
  },
  methods: {
    ...mapActions('account', ['logout'])
  }
}
</script>

<style>
#app-centered {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.background {
  background-color: #aaa;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 0;
}
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.toast {
  z-index: 1000;
}
</style>
